export const FIRST_STEP = 0;

export enum Step {
  Onboarding,
  Delegate,
  Service,
  Shipping,
  Billing,
  Payment,
  Review,
}

export interface IStep {
  key: Step;
  index: number;
  title: string;
  completed?: boolean;
}

export interface IStepControl {
  activeStepIndex: number;
  setActiveStep: (step: Step) => Promise<void>;
  isAllCompleted: () => boolean;
  lastStepIndex: Step;
  stepsMap: IStep[];
}
